import React, { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { endpoints } from '../services/api';
import AuthShell from '../components/AuthShell';
import { getFriendlyError } from '../components/errorUtils';

const RegisterPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const guideName = searchParams.get('guide');   // carried over from the share link

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (password !== confirmPassword) {
      setError('Passwords do not match.');
      return;
    }
    if (password.length < 8) {
      setError('Password must be at least 8 characters long.');
      return;
    }

    try {
      const response = await fetch(endpoints.auth.register, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password }),
      });

      if (!response.ok) {
        const errData = await response.json();
        throw new Error(errData.detail || 'Failed to register. Please try again.');
      }

      // ✅ Redirect to verify page with email so user can resend if needed
      navigate(`/auth/verify?email=${encodeURIComponent(email)}`);

    } catch (err) {
      setError(getFriendlyError(err.message, 'Register Page'));
    }
  };

  return (
    <AuthShell
      display="Record it once."
      points={[
        '14-day free trial, no credit card',
        'Live walkthroughs on any website',
        'PDF export with sensitive fields blurred',
      ]}
    >
        <h1 className="auth-title">Create your Michii account</h1>

        {guideName && (
          <p className="auth-success">Sign up to get access to “{guideName}”</p>
        )}
        <form onSubmit={handleSubmit} className="auth-form">
          {error && <p className="auth-error">{error}</p>}

          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="password">Password</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="confirm-password">Confirm password</label>
            <input
              type="password"
              id="confirm-password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
            />
          </div>

          <button type="submit" className="cta-button primary auth-button">
            Create account
          </button>
        </form>

        <p className="auth-switch">
          Already have an account? <Link to={`/login${window.location.search}`}>Log in</Link>
        </p>
    </AuthShell>
  );
};

export default RegisterPage;